import styled from 'styled-components';
export const S = {
    Layout: styled.div `
    display: flex;
    flex-direction: column;
    min-height: calc(100vh - 77px);
    flex-shrink: 0;

    width: 100%;
    padding: 30px 30px 40px;
  `,
    LayoutInputFields: styled.div `
    display: flex;
    flex-direction: column;

    margin-top: 30px;
  `,
    LayoutFooter: styled.div `
    display: flex;
    justify-content: center;

    width: 100%;
    margin-top: 40px;
  `,
    GapRow: styled.div `
    width: ${(props) => `${props.width}px`};
  `,
};
